import './App.css';
import AppRoutes from './Routes/Routes';
import Toast from './Modals/toast/Toast';
import { useSelector } from 'react-redux';
import Error503Page from './Modals/503/Page503';
import OfflineYuboyPage from './Modals/no internet/NoInternet';
import { useState,useEffect } from 'react';


function App() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const goOnline = () => setIsOnline(true);
    const goOffline = () => setIsOnline(false);
    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);
    return () => {
      window.removeEventListener("online", goOnline);
      window.removeEventListener("offline", goOffline);
    };
  }, []);

  console.log(isOnline)

  const isNetErr=useSelector((state)=>state?.network?.networkErr)
  if (!isOnline)return <OfflineYuboyPage></OfflineYuboyPage>
  if(isNetErr)return  <Error503Page></Error503Page>
  return (
    <>  
  
      <AppRoutes />
      <Toast />
    </>
  );
}

export default App;
